import React, { useState } from 'react';
import { Button, message, Upload } from 'antd';
import { ModalContainer } from './styles';
import Modal from 'antd/lib/modal/Modal';
import { CloseOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import { SKW_AUTH, SKW_PREFIX, SKW_URL } from '../../../../../../../utils/constants';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../store';
import api from '../../../../../../../service/api';
import Swal from 'sweetalert2';
import saveAs from 'file-saver';

interface ItensNotaProps {
  nuNota: number;
  title?: string;
}

const ModalUpload: React.FC<ItensNotaProps> = ({ nuNota, title }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const [loading, setloading] = useState<boolean>(false);
  const [anexos, setAnexos] = useState([]);

  const props = {
    action: `${SKW_URL}/upload?serviceName=${SKW_PREFIX}enviarDocumentoNota&accessKey=${SKW_AUTH}`,
    onChange(info: any) {
      try {
        if (info.file.status === 'done') {
          enviarDocumentoParceiro(info.fileList[0].response[0].filekey, info?.file?.name);
        }
      } catch (error) {
        message.error(`Upload do arquivo falhou.`);
      }
    },
    showUploadList: {
      showRemoveIcon: false,
    },
  };

  const enviarDocumentoParceiro = (key: string, name: string) => {
    try {
      setloading(true);
      api
        .post(`call?serviceName=${SKW_PREFIX}enviarDocumentoNota&token=${token}`, {
          chave: key,
          nuNota: nuNota,
          descricao: `${title ?? 'Anexo NF'}-${nuNota}`,
          nomeArquivo: name,
        })
        .then((res) => {
          Swal.fire({
            title: `Enviado com sucesso!`,
            html: '',
            icon: 'success',
            confirmButtonText: 'OK',
            showConfirmButton: false,
            timer: 1500,
          });
          setloading(false);
          getDocumentoParceiro();
        })
        .catch((err) => {
          Swal.fire({
            title: `Não foi possível enviar o anexo.`,
            html: err.response?.data.titulo,
            icon: 'error',
            showConfirmButton: false,
            timer: 1500,
          });
        });
    } catch (error) {}
  };
  const getDocumentoParceiro = () => {
    try {
      api
        .post(`call?serviceName=${SKW_PREFIX}getAnexos&token=${token}`, {
          filtro: {
            pk: [nuNota],
            instancia: 'CabecalhoNota',
          },
        })
        .then((res) => {
          setAnexos(res.data.anexos);
        })
        .catch((err) => {});
    } catch (error) {}
  };
  const getDownloadAnexo = (pkRegistro: string, nuAttach: number) => {
    try {
      api
        .post(
          `call?serviceName=${SKW_PREFIX}getDownloadAnexo&token=${token}`,
          {
            nuAttach: nuAttach,
            pkRegistro: pkRegistro,
          },
          {
            responseType: 'arraybuffer',
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          saveAs(blob, `${pkRegistro}.pdf`);
        })
        .catch((err) => {});
    } catch (error) {}
  };

  const showModal = () => {
    setIsModalVisible(true);
    getDocumentoParceiro();
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <>
      <Modal
        centered
        title="Anexar documentos"
        visible={isModalVisible}
        onCancel={() => handleCancel()}
        maskClosable={false}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={850}
        footer={[
          <Button key="back" type="ghost" size="middle" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}
      >
        <ModalContainer>
          <h4>Documentos anexados</h4>
          <ul>
            {anexos.map((item: { descricao: string; pkRegistro: string; nuAttach: number }) => {
              return (
                <li
                  onClick={() => getDownloadAnexo(item.pkRegistro, item.nuAttach)}
                  key={item.pkRegistro}
                  style={{ cursor: 'pointer' }}
                >
                  {item.descricao}
                  <DownloadOutlined style={{ fontSize: '22px' }} />
                </li>
              );
            })}
          </ul>

          <h4>Anexar documentos</h4>
          <Upload {...props} maxCount={1} multiple={false} accept=".xml,.pdf">
            <Button
              type="ghost"
              style={{ width: '100%' }}
              disabled={loading}
              icon={<UploadOutlined />}
            >
              Procurar arquivo
            </Button>
          </Upload>
        </ModalContainer>
      </Modal>
      <button
        style={{
          padding: 0,
          height: 'auto',
          border: 'none',
          background: 'none',
          color: '#1890ff',
          cursor: 'pointer',
        }}
        onClick={() => showModal()}
      >
        Anexar documentos
      </button>
    </>
  );
};

export default ModalUpload;
